import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import Layout from "./layout"
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'
import "./styles/solve.css"
import { Context } from '../context';
import { navRef, footerRef } from './refs';
import { CLOUDINARYURL, ENDPOINT, ENDPOINTGO, NetworkCall, ShowNotification } from "../utils/constants"
import AceEditor from "react-ace"
import "ace-builds/src-noconflict/mode-python"
import "ace-builds/src-noconflict/theme-github"
import "ace-builds/src-noconflict/theme-ambiance"
import "ace-builds/src-noconflict/theme-solarized_dark"
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-terminal"
import Axios from "axios"
import Cookie from 'js-cookie'

export default function Solve(props) {
    const [id, setId] = useState(null)
    const [markdown, setMarkDown] = useState('')
    const [code, setCode] = useState('')
    const context = useContext(Context)
    const editorRef = useRef(null)
    const [currentType, setCurrentType] = useState('')

    const [inputsUrl, setInputUrl] = useState('')
    const [languages, setlanguages] = useState(null)

    const [testCaseResult, setTestCaseResult] = useState(null)


    const readQuery = () => {
        const params = new URLSearchParams(props.location.search)
        const id = params.get("id")
        const prburl = params.get('prburl')
        const codeTemplateUrl = params.get('codeurl')
        const inputsurl = params.get('inputsurl')
        return { id, prburl, codeTemplateUrl, inputsurl }
    }
    const readFile = async (_url) => {
        fetch(_url)
            .then((res) => res.text())
            .then((data) => {
                setMarkDown(data)
            })
    }
    const readCodeFile = async (_url) => {
        fetch(_url)
            .then((res) => res.text())
            .then((data) => {
                setCode(data)
            })
    }
    const fetchProblem = () => {
        const { id } = readQuery()
        Axios.post(ENDPOINT + "/problems/solve", { id })
            .then(res => {
                setlanguages(res.data.languages)
                // readCodeFile(codeTemplateUrl)
                setCurrentType(res.data.languages[0].languageName)
                readCodeFile(res.data.languages[0].codeTemplateUrl)
            })
            .catch(err => {

            })
    }
    useEffect(() => {
        let { id, prburl, codeTemplateUrl, inputsurl } = readQuery()
        // let curr = context.currentProblemState[id]
        // setInputUrl(inputsurl)
        readFile(CLOUDINARYURL + prburl)
        fetchProblem()
        // readCodeFile(codeTemplateUrl)
        setId(id)

        footerRef.current.style.display = 'none'

        return () => {
            navRef.current.style.display = 'flex'
            footerRef.current.style.display = 'flex'
            // let temp = context.currentProblemState
            // temp[id].codeTemplate = editorRef.current.props.value
            // context.setCurrentProblemState(temp)
            let screen = document.getElementsByTagName('body')[0]
            if (window.innerWidth == screen.width && window.innerHeight == screen.height)
                document.exitFullscreen()
        }
    }, [])

    const handleOnChange = (text) => {
        setCode(text)
    }
    const handleFullScreen = () => {
        navRef.current.style.display = navRef.current.style.display === 'none' ? 'flex' : 'none'
        let elem = document.getElementsByTagName('body')[0]
        if (navRef.current.style.display == 'flex') {
            document.exitFullscreen()
            return
        }
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
            elem.msRequestFullscreen();
        }

    }
    let locknetwork = false
    const handleSubmit = () => {
        //check if user has changed nothing
        if (locknetwork) return
        let lang_id = null
        for (let i = 0; i < languages.length; i++) {
            if (currentType == languages[i].languageName) {
                lang_id = languages[i]._id
                break;
            }
        }
        if (!lang_id) return

        let token = Cookie.get('token')
        const submitData = {
            code: code,
            _id: lang_id, //id of the language
            languageName: currentType,
            token

        }
        locknetwork = true
        setTestCaseResult(null)
        let loader = document.getElementById("loader")
        loader.style.display = 'block'

        const headers = {
            'Content-Type': 'application/json'
        }

        Axios.post(ENDPOINT + "/problems/submit", submitData, { headers })
            .then(res => {
                locknetwork = false
                loader.style.display = 'none'
                const { all_passed, testcase_result, syntaxError } = res.data
                if (syntaxError) {
                    ShowNotification("Error in code (exit with status 1)", "red", 3000)
                    return
                }
                let temp = []
                for (const [key, value] of Object.entries(testcase_result)) {
                    temp.push([key, value])
                }
                setTestCaseResult(temp)

                if (all_passed) {
                    ShowNotification("Congrats!🎉", 'green', 5000)
                }
                locknetwork = false
                // loader.style.display = 'none'
            })
            .catch(err => {
                ShowNotification("Something went wrong", 'red', 4000)
                locknetwork = false
                loader.style.display = 'none'
            })
    }

    const handleExpandEditor = () => {
        let l = document.getElementById('sol-left');

        l.style.flex = l.style.flex == '0 1 0%' ? '1' : '0';
        let fa_l = document.getElementById('sol-left-chevoron');
        // return
        if (fa_l.classList[1] == 'fa-chevron-left') {
            //expanding editor
            l.style.padding = '0px'

            fa_l.classList.remove('fa-chevron-left')
            fa_l.classList.add('fa-chevron-right')
        } else {
            //shrinking editor
            l.style.padding = '0.5rem'
            fa_l.classList.remove('fa-chevron-right')
            fa_l.classList.add('fa-chevron-left')
        }
    }
    const handleLanguageSelect = (l) => {
        setCurrentType(l.languageName)
        readCodeFile(l.codeTemplateUrl)
    }
    function showLanguages() {
        document.getElementById("sol-myDropdown").classList.toggle("show");
    }

    // Close the dropdown menu if the user clicks outside of it
    window.onclick = function (event) {
        if (!event.target.matches('.sol-dropbtn')) {
            var dropdowns = document.getElementsByClassName("sol-dropdown-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains('show')) {
                    openDropdown.classList.remove('show');
                }
            }
        }
    }

    const showTestcaseResults = () => (
        <div className="sol-testcase-wrapper" >
            {
                testCaseResult && testCaseResult.map(t => {
                    if (t[1] == 'Passed')
                        return (
                            <span className={`sol-each-testcase sol-Passed`}> {t[0].split("_").join(" ")}: {t[1]} </span>
                        )
                    {/* if (t[1] == 'Falied') */ }
                    return (
                        <span className={`sol-each-testcase sol-Failed`}> {t[0].split("_").join(" ")}: {t[1]} </span>
                    )
                })
            }
        </div>
    )
    // document.onclick = hideMenu;
    // document.oncontextmenu = rightClick;

    // function hideMenu() {
    //     document.getElementById(
    //         "contextMenu").style.display = "none"
    // }

    // function rightClick(e) {
    //     e.preventDefault();

    //     if (document.getElementById(
    //         "contextMenu").style.display == "block")
    //         hideMenu();
    //     else {
    //         var menu = document
    //             .getElementById("contextMenu")

    //         menu.style.display = 'block';
    //         menu.style.left = e.pageX + "px";
    //         menu.style.top = e.pageY + "px";
    //     }
    // }
    const [currentThem, setCurrentThem] = useState("solarized_dark")
    const handleTheme = (e) => {
        setCurrentThem(e.target.textContent)
    }
    function showTheme() {
        document.getElementById("sol-myDropdown-theme").classList.toggle("show");
    }

    return (
        <Layout>
            <div className="sol-wrapper">
                <div className="sol-left shrink" id="sol-left">
                    <ReactMarkdown plugins={[gfm]} children={markdown} />
                </div>
                <div className="sol-right" id="sol-right">
                    {/* <div class="sol-dropdown">
                        <button class="sol-dropbtn" onClick={showLanguages}>{currentType}</button>
                        <div id="sol-myDropdown" class="sol-dropdown-content">
                            {
                                languages && languages.map(l => <span onClick={() => { handleLanguageSelect(l) }}>{l.languageName}</span>)
                            }
                        </div>
                    </div> */}
                    <div className="sol-submission-wrapper">


                        <div class="sol-dropdown">
                            <button class="sol-dropbtn" onClick={showLanguages}>{currentType}</button>
                            <div id="sol-myDropdown" class="sol-dropdown-content">
                                {
                                    languages && languages.map(l => <span onClick={() => { handleLanguageSelect(l) }}>{l.languageName}</span>)
                                }
                            </div>
                        </div>
                        <div class="sol-dropdown">
                            <button class="sol-dropbtn" onClick={showTheme}>{currentThem}</button>
                            <div id="sol-myDropdown-theme" class="sol-dropdown-content">
                                <span onClick={handleTheme}>solarized_dark</span>
                                <span onClick={handleTheme}>monokai</span>
                                <span onClick={handleTheme}>github</span>
                                <span onClick={handleTheme}>terminal</span>
                            </div>
                        </div>
                        <div onClick={handleExpandEditor}><i className="fa fa-chevron-left" aria-hidden="true" id="sol-left-chevoron"></i></div>
                        <div onClick={handleFullScreen}><i className="fa fa-arrows-alt" aria-hidden="true"></i></div>
                        {/* <div onClick={handleTheme}>Theme</div> */}
                    </div>
                    <AceEditor
                        ref={editorRef}
                        mode={currentType}
                        theme={currentThem}
                        onChange={handleOnChange}
                        name={id}
                        editorProps={{ $blockScrolling: true }}
                        fontSize={17}
                        highlightActiveLine={true}
                        showGutter={true}
                        setOptions={{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true
                        }}
                        value={code}
                        style={{
                            width: '100%',
                        }}
                    />
                    <div className="sol-submission-wrapper">
                        {/* <div>Run</div> */}
                        <div className="lds-dual-ring" id="loader" style={{ borderWidth: 0 }}></div>
                        <div onClick={handleSubmit} style={{ color: 'white' }}>Submit</div>
                    </div>
                    {testCaseResult && showTestcaseResults()}
                </div>
            </div>
        </Layout>
    )
}
